import {ChangeDetectorRef, Directive, HostBinding, Input, OnInit} from '@angular/core';

import {RolesService} from './roles.service';

@Directive({
  selector: '[gp-roles]'
})
export class RolesDirective implements OnInit {

  @Input() public userRoles: string[];
  @Input() public isReverse: boolean = false;
  private isVisible: boolean = true;

  constructor(private rolesService: RolesService,
              private cd: ChangeDetectorRef) {
  }

  public ngOnInit(): void {
    this.checkRoles();
  }

  @HostBinding('class.hide')
  public get display(): boolean {
    return this.isReverse ? this.isVisible : !this.isVisible;
  }

  private checkRoles() {
    this.isVisible = this.rolesService.hasRole(...this.userRoles);
    this.cd.markForCheck();
  }
}
